import React from "react"
import moment from "moment"
import { FormattedMessage, useIntl } from "react-intl"
import { getMailTo } from "../../helpers/contact"
import { EMAIL_SUPPORT_CL } from "../../constants/contact"
import { isFeatureEnabled } from "config/feature-flags"
import {
	MEDALLIA_FEATURE_FLAG,
	MEDALLIA_FEEDBACK_FORM_ID,
} from "constants/medallia"
import MedalliaApi from "components/Infrastructure/medallia"

import "./index.scss"

export const getFeedbackForm = (subject: string, asModal: boolean = true) => {
	if (isFeatureEnabled(MEDALLIA_FEATURE_FLAG)) {
		if (asModal) {
			const { openForm } = MedalliaApi()
			openForm(MEDALLIA_FEEDBACK_FORM_ID)
		} else {
			getMailTo(EMAIL_SUPPORT_CL, subject)
		}
	}
}

const FeedbackFooter: React.FunctionComponent = () => {
	const intl = useIntl()

	const GetTranslatedSubject = () => {
		return intl.formatMessage({ id: "phronesis.footer.feedback.subject" })
	}

	return (
		<div className="feedback-footer" data-testid="feedback-footer">
			<div className="feedback-footer-copyright">
				<FormattedMessage
					id="phronesis.footer.copyright"
					values={{ year: moment().format("YYYY") }}
				/>
			</div>
			<div>
				<span>
					<FormattedMessage id="phronesis.footer.feedback.description" />
				</span>
				<a
					data-testid="feedback-button"
					onClick={() => getFeedbackForm(GetTranslatedSubject(), false)}
				>
					<FormattedMessage id="phronesis.footer.feedback.button" />
				</a>
			</div>
		</div>
	)
}

export default FeedbackFooter
